import $ from 'jquery';
import 'summernote';

export default function (context) {

    var ui = $.summernote.ui;
    var options = context.options;
    var self = this;
  
    this.events = {
        'summernote.mousedown': function (we, e) {
            if (self.update(e.target)) {
                e.preventDefault();
            }
        },
        'summernote.keyup summernote.scroll summernote.change summernote.dialog.shown': function () {
            self.update();
        }/*,
        'summernote.change summernote.dialog.shown': function () {
            self.hide();
        },
        'summernote.focusout': function (we, e) {
            self.hide();
        }*/
    };

    this.shouldInitialize = function () {
        return options.popover.munit && options.popover.munit.length;
    };
    
    this.initialize = function () {
      
        this.$popover = ui.popover({
            className: 'note-image-popover'
        }).render().appendTo('body');

        var $content = this.$popover.find('.popover-content');
        context.invoke('buttons.build', $content, options.popover.munit);
    };
    
    this.destroy = function () {
        this.$popover.remove();
    };
    
    this.update = function (target) {
        var $editingArea = context.layoutInfo.editingArea;
        var $handle = $editingArea && $editingArea.find('.note-handle');
        var $selection = $handle && $handle.find('.note-control-selection');
        var $itemObj = $(target).closest('.article-item-unit');
      
        if($itemObj.length > 0) {
            var pos = $itemObj.position();
    
            // include margin
            var objSize = {
              w: $itemObj.outerWidth(true),
              h: $itemObj.outerHeight(true)
            };
  
            $selection && $selection.css({
              display: 'block',
              left: pos.left,
              top: pos.top,
              width: objSize.w,
              height: objSize.h
            }).data('target', $itemObj); // save current image element.
  
  
            var itemPos = $itemObj.offset();
            this.$popover.css({
                display: 'block',
                left: itemPos.left,
                top: itemPos.top
            });
    
            var sizingText = objSize.w + 'x' + objSize.h;
            $selection.find('.note-control-selection-info').text(sizingText);
            context.invoke('editor.saveTarget', target);
        } else {
            this.hide()
        }
    };
    
    this.hide = function () {
        this.$popover.hide();
    };
}
